type SentryConfig = {
  SentryDSN: string;
  SentryRelease: string;
  TracesSampleRate: number;
};

const rawTracesSampleRate = import.meta.env.VITE_TRACES_SAMPLE_RATE;

export const sentryConfig: SentryConfig = {
  SentryDSN: import.meta.env.VITE_SENTRY_DSN,
  SentryRelease: import.meta.env.VITE_SENTRY_RELEASE,
  TracesSampleRate: rawTracesSampleRate ? +rawTracesSampleRate : 1.0,
};

// Browser errors not worth reporting. Each is matched against the error's message.
export const ignoredClientErrors: RegExp[] = [
  // Headless UI's iOS scroll lock (handle-ios-locking) keeps a touchmove listener after a dialog closes and throws on
  // every touch on iPhones, a million or more events a day (Sentry ONLINE-ORDERING-REMIX-DEV-JA). It's inside the
  // library (unchanged in 2.2.10) and has no visible effect.
  /\(evaluating '[\w$]+\(\)\.containers'\)/,
  // The connection dropped mid-request (Safari, Chrome, Firefox wording). The API's own failures are reported by
  // the server.
  /^(TypeError: )?Load failed( \(.*\))?$/,
  /^(TypeError: )?Failed to fetch( \(.*\))?$/,
  /NetworkError when attempting to fetch resource/,
  // A tab still on the previous release asks for code that's gone; Remix reloads the page itself
  /^Error loading route module .*, reloading page/,
  /Importing a module script failed/,
  /Failed to fetch dynamically imported module/,
  // In-app browsers and extensions injecting their own scripts
  /\[AutofillPlugin\]/,
  /window\.webkit\.messageHandlers/,
  // The Google Maps script failing to load (blocked or offline); the page carries on without it
  /^injectScript error/,
  /^(Error: )?\[object Event\]$/,
];
